/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure.
 *
 * OpenAPI spec version: v0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { decodeStringOrArrayBuffer} from './ModelHelper'
export class Body3 {
  constructor(json: JSON | any) {
    Object.assign(this as Body3, json, json.attachment ? { attachment: decodeStringOrArrayBuffer(json.attachment) } : {})
  }

  attachment?: ArrayBuffer
}
